export enum EVisualisation {
  STACKED_POLAR_CHART = 'stacked_polar_chart',
  PARETO_CHART = 'pareto_chart',
  STACKED_BAR_CHART = 'stacked_bar_chart',
  TABLE = 'table',
  CLUSTERED_STACKED_BAR_CHART = 'clustered_stacked_bar_chart',
}
